'use client';

import { useRoomContext } from '@livekit/components-react';

export function useOptionalRoomContext() {
  try {
    return useRoomContext();
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.debug('useOptionalRoomContext: room context não encontrado, retornando null');
    }
    return null;
  }
}
